import { VscLoading } from "react-icons/vsc";
import "./Carregamento.css";

const Carregamento = () => {
    return (  
        <div className="box-carregamento">
            <h1 className="texto-carregamento">Carregando...</h1>
            <VscLoading className="icone-carregamento"/>
        </div>
    );
}
 
export default Carregamento;